import { Result } from '../../../common-models/Result';
import { HttpServiceBase } from '../../../common-services/Http/HttpServiceBase';
import { SaveOrderImportInput } from './SaveOrderImportInput';
import { SaveOrderImportOutput } from './SaveOrderImportOutput';

export class SaveOrderImportService extends HttpServiceBase {

    handle = (input: SaveOrderImportInput): Promise<Result<SaveOrderImportOutput>|null> => {
        const promise = this.http.post<Result<SaveOrderImportOutput>, SaveOrderImportInput>(`${this.baseUrlSislogApi}/v2/order-import`, input);
        return promise;
    }
}